import { ActivatedRoute, Router } from '@angular/router';
import { Component, inject, OnInit } from '@angular/core';
import { NotificationService } from './service/notification.service';

@Component({ template: '' })
export abstract class BaseListComponent<TYPE, FILTER extends Record<string, any>> implements OnInit {
  list!: TYPE[];
  page!: { search: () => void; totalElements: number; size: number; number: number };
  filter: FILTER = {} as any;
  route = inject(ActivatedRoute);
  router = inject(Router);
  toastr = inject(NotificationService);

  public async search() {
    const queryParams: Record<string, any> = { ...this.filter, page: this.page.number };
    for (const key in queryParams) {
      if (queryParams[key] === '' || queryParams[key] === 0 || queryParams[key] === false) {
        queryParams[key] = undefined;
      }
    }
    await this.router.navigate([], { relativeTo: this.route, queryParams });
  }

  /**
   * Applies a filter change and returns to the first page. `search()` alone keeps the current
   * page number, so changing a filter from page 3 lands on page 3 of a possibly one-page result —
   * an empty list that looks like "no matches".
   */
  public async searchFromFirstPage(patch: Partial<FILTER>) {
    this.filter = { ...this.filter, ...patch };
    this.page.number = 0;
    await this.search();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.filter = { ...(params || {}) } as FILTER;
    });

    this.route.data.subscribe(({ list }) => {
      this.list = list.content;
      this.page = { ...list, search: () => this.search() };
    });
  }
}
